import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./context/LanguageContext";
import { HeadManager } from "./components/HeadManager";
import { Navbar } from "./components/Navbar";
import { Hero } from "./components/Hero";
import { Leistungen } from "./components/Leistungen";
import { Ablauf } from "./components/Ablauf";
import { Footer } from "./components/Footer";
import { Offertanfrage } from "./components/Offertanfrage";
import {
  PrivacyPage,
  ImprintPage,
  NotFoundPage,
} from "./components/LegalPages";

const Home = () => (
  <main
    data-testid="page-home"
    className="relative bg-stein-100 text-stein-900"
  >
    <Navbar />
    <Hero />
    <Leistungen />
    <Ablauf />
    <Footer />
  </main>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <LanguageProvider>
          <HeadManager />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/offerte" element={<Offertanfrage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/imprint" element={<ImprintPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </LanguageProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
